import css from 'styled-jsx/css';

const ShippingTooltipStyles = css.global`
  .shipping-tooltip {
    background: #333333 !important;
    color: #fefeff;
    border-radius: 8px;
    padding: 16px;
    gap: 12px;
    box-shadow: 0px 4px 20px 0px #1d1d1d33;
    max-width: 302px;
    border-style: none;
    --popper-arrow-size: 16.97px;
    margin-bottom: 10px;

    header {
      font-family: 'Helvetica' !important;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      padding: 0px;
    }

    .chakra-popover__body {
      font-family: 'Helvetica' !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      padding: 0px;
    }

    .chakra-popover__arrow {
      background: #333333 !important;
    }

    .chakra-popover__close-btn {
      top: 14px;
      right: 16px;

      svg {
        width: 12.41px;
        height: 12.41px;
        color: #fefeff !important;
      }
    }
  }
`;

export default ShippingTooltipStyles;
